module.exports = __webpack_public_path__ + "static/media/uppvarmning_768.3cdb4920.jpg";